<span [class]="getBadgeClass()" class="status-badge">
    {{label}}
</span>